var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(this.properties, function(item, index) {
      return _c(
        "el-row",
        { key: index, staticStyle: { padding: "10px 0" } },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-card",
                { staticStyle: { width: "100%" } },
                [
                  _c(
                    "el-row",
                    { staticStyle: { padding: "5px 0" } },
                    [
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("span", { staticClass: "label-title" }, [
                          _vm._v("Dwelling")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("span", { staticClass: "label-desc" }, [
                          _vm._v(_vm._s(item.dwellingNumber))
                        ])
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { staticStyle: { padding: "5px 0" } },
                    [
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("span", { staticClass: "label-title" }, [
                          _vm._v("Address")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("span", { staticClass: "label-desc" }, [
                          _vm._v(_vm._s(item.address))
                        ])
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { staticStyle: { padding: "5px 0" } },
                    [
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("span", { staticClass: "label-title" }, [
                          _vm._v("Price")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("span", { staticClass: "label-desc" }, [
                          _vm._v("$ " + _vm._s(_vm.numberWithCommas(item)))
                        ])
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { staticStyle: { padding: "5px 0" } },
                    [
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("span", { staticClass: "label-title" }, [
                          _vm._v("Status")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("span", { staticClass: "label-desc" }, [
                          _vm._v(_vm._s(_vm.setStatus(item)))
                        ])
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { staticStyle: { padding: "5px 0" } },
                    [
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("span", { staticClass: "label-title" }, [
                          _vm._v("Date")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("span", { staticClass: "label-desc" }, [
                          _vm._v(_vm._s(item.reservedDate))
                        ])
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { staticStyle: { padding: "5px 0" } },
                    [
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("span", { staticClass: "label-title" }, [
                          _vm._v("Agent")
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        _vm._l(item.agentPojoList, function(agent) {
                          return _c("div", { staticClass: "label-desc" }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(agent.firstName) +
                                  " " +
                                  _vm._s(agent.lastName)
                              )
                            ])
                          ])
                        }),
                        0
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { staticStyle: { padding: "5px 0" } },
                    [
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("span", { staticClass: "label-title" }, [
                          _vm._v("Legal Rep.")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("span", { staticClass: "label-desc" }, [
                          _vm._v(_vm._s(item.legalRepName))
                        ])
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-78998903", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78998903","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/reservedPropertyCard.vue
// module id = null
// module chunks = 